import styles from "./PlanTabs.module.css";

export type PlanType = "core" | "plus" | "premium";

interface PlanTabsProps {
	activePlan: PlanType;
	onPlanChange: (plan: PlanType) => void;
}

export function PlanTabs({ activePlan, onPlanChange }: PlanTabsProps) {
	const plans: { id: PlanType; label: string }[] = [
		{ id: "core", label: "Core plan" },
		{ id: "plus", label: "Plus plan" },
		{ id: "premium", label: "Premium plan" },
	];

	return (
		<div className={styles.tabs}>
			{plans.map((plan) => (
				<button
					key={plan.id}
					type="button"
					className={`${styles.tab} ${activePlan === plan.id ? styles.active : ""}`}
					onClick={() => onPlanChange(plan.id)}
				>
					{plan.label}
				</button>
			))}
		</div>
	);
}
